import React, { useState, useEffect } from 'react';
import { Checkbox, Grid, Icon, IconButton, Typography } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import cx from 'classnames'
import {makeStyles} from '@mui/styles'
import Iconify from '../../../components/iconify';

/**
 * @module Layouts/Registration/components/DocumentElement
 * @description This is a functional component in JavaScript React that renders a document element with a checkbox,
 * label, and button. It takes in two props, `document` and `onChange`, and uses them to update the
 * state of the document element when the checkbox or button is clicked. It also uses the `makeStyles`
 * hook from MUI to define the styles for the component.
 * @returns {React.ReactElement} The `DocumentElement` component is being returned as a View.
 */

/**
 * 
 * @typedef DocumentElement
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Object} document - The document element with information
 * @property {Number} document.id - The id of the document
 * @property {Number} document.description - The description of the document
 * @property {Boolean} document.visited - Variable that handles if a document is visited or not
 * @property {Boolean} document.accepted - Variable that handles if a document is accepted or not
 

 * @returns {React.ReactElement} The `DocumentElement` component is being returned as a View.
 */


const DocumentElement = (props) => {

    const {document, onChange} = props
    const classes = useStyles()

    /**
     * @function onGoToDocument
     * @description The function sets a "visited" property to true on a copy of the document object and calls the
     * onChange function with the updated object and a 'view' argument.
     * @param document - Selected document agreement
     */
    const onGoToDocument = () => {
        let _document = {...document}
        _document.visited = true
        onChange(_document, 'view')
        //window.open(document?.url,'_target')
    }

    /**
     * @function onToggleDocument
     * @description This function toggles the "accepted" property of the "document" object and calls the "onChange"
     * function with the updated object and a string parameter.
     * @param document - Selected document agreement
     */
    const onToggleDocument = () => {
        let _document = {...document}
        _document.accepted = !document.accepted
        onChange(_document, 'check')
    }

    return ( 
        <div className={classes.root}>
            <Grid container alignItems='center'>
                <Grid item>
                    <Checkbox id={`${document?.id}`} color='primary' checked={Boolean(document?.accepted)} onChange={onToggleDocument} disabled={!(document?.visited)}/>
                </Grid>
                <Grid item xs>
                    <div className={classes.content}>
                        <Grid container alignItems='center'>
                            <Grid item xs>
                                <Typography variant='body1' className={classes.label}>{document?.description}</Typography>
                            </Grid>
                            <Grid item>
                                <IconButton size='small' 
                                className={cx({
                                    [classes.button]:true,
                                    [classes.button_visited]:document?.visited
                                })} 
                                onClick={onGoToDocument}>
                                    <Iconify icon="bi:arrow-right-short" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
                
            </Grid>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    button:{
        background:"#8798ad",
        color:'white',
        '&:hover':{
            background:"#8798ad",
        }
    },
    button_visited:{
        background:theme.palette.primary.dark,
        '&:hover':{
            background:theme.palette.primary.dark,
        }
    },
    content:{
        borderBottom:`1px solid ${'#EFEFEF'}`,
        padding:'8px 0px'
    },
    label:{
        fontWeight:500
    }
}))
 
export default DocumentElement;